import React from 'react';
import classnames from 'classnames';

import Shape from 'ati-ui-react/components/Shape';
import Button from '@components/button';
import IconWithActive from '@components/icon-with-active';
import Icon from '@components/icon';
import { openNewTab } from '../../../utils';

import * as styles from './Banner.scss';

const Banner = (props) => {
  const {
    url,
    closeBanner,
    primaryText,
    secondaryText,
    buttonText,
    imageUrl,
    imageAlt = 'banner-image',
    className,
    clickCallback,
  } = props;

  const handleClick = () => {
    if (clickCallback) {
      clickCallback();
    }
    openNewTab(url);
  };

  return (
    <Shape
      shadow="true"
      className={classnames(styles.banner, className)}
    >
      <div className={styles.bannerInfo}>
        <img
          alt={imageAlt}
          className={styles.image}
          src={imageUrl}
        />
        <div>
          <span className={styles.text}>
            {primaryText}
          </span>
          <span className={styles.bannerSecondaryText}>
            {secondaryText}
          </span>
        </div>
      </div>
      <div className={styles.bannerButtons}>
        <Button
          onClick={handleClick}
          preventDefault
          className={styles.tryButton}
          theme="success"
          size="small"
        >
          {buttonText}
        </Button>
        <div className={styles.closeButton}>
          <IconWithActive
            defaultIcon={
              <Icon name="ic_close-out" size="s" color="var(--glz-color-neutral-tone-4)" />
            }
            activeIcon={
              <Icon name="ic_close-out" size="s" color="var(--glz-color-neutral-tone-5)" />
            }
            onClick={closeBanner}
          />
        </div>
      </div>
    </Shape>
  );
};

export default Banner;
